/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/require-default-props */
/* eslint-disable react/jsx-props-no-spreading */
import { Link, Typography, TypographyTypeMap } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function RouteLink({
  link,
  description,
  handleClick,
  typographyProps: props = {},
  color = 'secondary' // color for route link text
}: {
  link: string;
  description: string;
  handleClick?: () => void;
  typographyProps?: TypographyTypeMap['props'];
  // set color defaul value
  color?: string;
}) {
  const navigate = useNavigate();
  const handleNavigation = (e: React.SyntheticEvent) => {
    e.preventDefault();
    e.stopPropagation();
    navigate(link);
    if (typeof handleClick === 'function') {
      handleClick();
    }
  };

  // get the current url for the link
  const currentUrl = window.location.href;

  return (
    <Typography {...props} style={{width:"100%"}}>
      <Link
        color={color}
        textTransform='capitalize'
        onClick={handleNavigation}
        href={link}
        fontWeight='400'
        sx={{ textDecoration: 'none', display:'block'}}
      >
        {description}
      </Link>
    </Typography>
  );
}
